import React from 'react';
import { useSelector } from 'react-redux';

import { Stepper, StepperNumber } from '../Stepper';
import * as wizardSelectors from '../../redux/wizard/selectors';
import styles from './WizardStepper.module.scss';

const STEPPER_STEPS = [
  { label: 'Elige un plan', stepName: 'plans', description: 'Siguiente: Agrega más coberturas' },
  {
    label: 'Agrega más coberturas',
    stepName: 'quote',
    description: 'Siguiente: Recibe tu cotización',
  },
  { label: 'Recibe tu cotización', stepName: 'summary', description: 'Proceso completado' },
];

function WizardStepper() {
  const currentStepName = useSelector(wizardSelectors.getCurrentStep);
  const stepIndex = STEPPER_STEPS.findIndex((s) => s.stepName === currentStepName);
  const isLastStep = stepIndex === STEPPER_STEPS.length - 1;
  const currentStep = isLastStep ? STEPPER_STEPS.length + 1 : stepIndex + 1;

  return (
    <Stepper activeStep={currentStep} className={styles.stepperContainer}>
      {STEPPER_STEPS.map((step, index) => (
        <StepperNumber key={index} label={step.label} description={step.description} />
      ))}
    </Stepper>
  );
}

export default WizardStepper;
